import { useParams, useNavigate } from 'react-router-dom';

export function useOrgNavigate() {
  const { orgId } = useParams<{ orgId: string }>();
  const navigate = useNavigate();

  return (path: string, options = {}) => {
    navigate(`/org/${orgId}/${path}`, options);
  };
}